import { createIcon } from '@chakra-ui/icons';

export const CameraFlash = createIcon({
  displayName: 'CameraFlash',
  viewBox: '0 0 10 10',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <g id="camera-flash 2">
        <g id="Group">
          <path
            id="Vector"
            d="M5.75065 0H3.37565C3.12565 0 2.87565 0.1875 2.75065 0.4375L1.50065 4.8125C1.37565 5.25 1.68815 5.625 2.06315 5.625H4.37565L3.43815 10L8.00065 4.125C8.31315 3.75 8.00065 3.125 7.50065 3.125H5.62565L6.31315 0.8125C6.43815 0.375 6.12565 0 5.75065 0Z"
            fill="#977334"
          />
        </g>
      </g>
    </svg>,
  ],
});
